import StaticLayout from "../../layout/StaticPageLayout";
import Hero from "../../views/static/Landing/Hero";
import "react-datepicker/dist/react-datepicker.css";
import UnderlinedTitle from "../../components/UnderlinedTitle";
import Search from "../../views/static/Landing/Search";

export default function Landing() {
  return (
    <StaticLayout>
      <div className=" absolute h-[90vh] md:h-[90vh] z-10 bg-opacity-50  bg-black  top-0 right-0 left-0   "></div>

      <div className=" h-[90vh] bg-reen-400  ">
        <Hero />
      </div>
      <div className="  bg-red-00 max-h-[70vh] md:min-h-1 overflow-scroll md:overflow-visible my-auto  mx-auto absolute top-0 right-0 left-0  md:w-[100%] px-3  z-10   mt-[150px] mb-20 md:mb-0  flex flex-col gap-5 text-white items-center bg-red-00/20  ">
        <div className="md:w-[90%] flex flex-col gap-5 text-white items-center ">
          <p className=" text-[20px]  md:text-[50px] md:leading-[70px] md:w-[60%] font-bold text-center ">
            Book Cheap Flights in Nigeria with Flightpadi
          </p>
          <p className="  text-center text-sm md:text-[15px] ">
            Flightpadi <b>does the hard work for you</b> – from finding the
            cheapest flights to creating personalized travel itineraries​
          </p>
        </div>
        <Search />
      </div>
      <main className=" mt-6 md:mt-0 ">
        <UnderlinedTitle
          text="What is Flightpadi All About?
"
        />
      </main>
    </StaticLayout>
  );
}
